import { observer, useLocalObservable } from 'mobx-react-lite'
import React from 'react'
import { TagsControl, TagsSelect } from 'entities/Tags'
import { type ITagActionItem } from 'entities/TemplateActions/actions.tsx'
import { MessageModalActions } from 'widgets/TemplateActions/ui/MessageModalActions/MessageModalActions.tsx'
import styles from './styles.module.scss'

export type IAddTagContentData = { tags: ITagActionItem[] }

export type IAddTagContentProps = {
  onClose: () => void
  onSave: (data: IAddTagContentData) => void
  data?: IAddTagContentData
  onDelete?: () => void
  canCreate?: boolean
}

export const AddTagContent = observer(
  ({ onClose, onSave, data, onDelete, canCreate }: IAddTagContentProps) => {
    const control = useLocalObservable(() => new TagsControl(data?.tags.map((item) => item.id)))

    const tags = control.tags.map((tag): ITagActionItem => ({ id: tag.id, name: tag.name }))

    const handleSave = () => {
      onSave({ tags })
      onClose()
    }

    const handleDelete = onDelete
      ? () => {
          onDelete()
          onClose()
        }
      : undefined

    return (
      <>
        <div className={styles.content}>
          <TagsSelect
            control={control}
            canCreate={canCreate}
            placeholder={canCreate ? 'Search or create' : 'Search'}
            searchPlaceholder={'Search'}
          />
        </div>
        <MessageModalActions
          onDelete={handleDelete}
          onSave={handleSave}
          onCancel={onClose}
          disabledSave={!tags.length}
        />
      </>
    )
  }
)
